import React from 'react'

import { Container, useTheme } from '@mui/material'

import { Message as MessageType } from '../../types/message'
import { Attachment } from './Attachment'
import { getMessageTime } from '../../helpers/message'
import { AvatarCircle } from '../../components/AvatarCircle/AvatarCircle'

interface IMessageProps {
    message: MessageType
    preview?: boolean
    attachmentSize?: number
}

export const Message: React.FC<IMessageProps> = ({
    message,
    preview,
    attachmentSize,
}) => {
    const theme = useTheme()

    const attachments = message.attachments
        ? message.attachments.map((a, idx) => (
              <Attachment
                  key={`ATTACHMENT_${idx}`}
                  attachment={a.file}
                  theme={theme}
                  size={attachmentSize}
                  uploaded={a.uploaded}
              />
          ))
        : undefined

    //for styling the message box
    const messageStyle: React.CSSProperties = {
        marginBottom: theme.spacing(1),
        padding: theme.spacing(0.5),
        backgroundColor: theme.palette.grey[200],
        boxShadow: theme.shadows[1],
        display: 'flex',
        alignItems: 'flex-start',
        flexDirection: 'column',
    }

    if (preview) {
        messageStyle.maxHeight = 100
        messageStyle.overflow = 'hidden'
    }

    const displayDate = getMessageTime(new Date(message.created_date))
    return (
        <Container style={messageStyle}>
            <Container
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'flex-start',
                    padding: 0,
                    marginBottom: theme.spacing(1),
                }}
            >
                <div style={{ marginRight: theme.spacing(2), width: 45 }}>
                    <AvatarCircle
                        image={message.sender_profile_picture ?? undefined}
                        text={message.sender_name}
                        initials
                    />
                </div>
                <Container
                    style={{
                        padding: 0,
                        marginBottom: theme.spacing(1),
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                    }}
                >
                    <span
                        style={{
                            ...theme.typography.body1,
                            fontWeight: theme.typography.fontWeightBold,
                        }}
                    >
                        {message.sender_name}
                    </span>
                    <span
                        style={{
                            ...theme.typography.caption,
                        }}
                    >
                        {displayDate}
                    </span>
                </Container>
            </Container>

            <Container style={{ flex: 1, padding: 0 }}>
                {attachments && (
                    <Container
                        style={{
                            padding: 0,
                            marginBottom: theme.spacing(1),
                            flexWrap: 'wrap',
                        }}
                    >
                        {attachments}
                    </Container>
                )}

                <div
                    dangerouslySetInnerHTML={{
                        __html: message.content,
                    }}
                    style={{
                        ...theme.typography.subtitle1,
                        width: '100%',
                    }}
                />
            </Container>
        </Container>
    )
}
